import * as Yup from "yup";
import { parseCurrencyString } from "@/utils/parseCurrencyString";

export const saleSchema = Yup.object().shape({
  payment_method_id: Yup.mixed<number | string>()
    .required("Método de pagamento é obrigatória")
    .test(
      "not-empty",
      "Método de pagamento é obrigatória",
      (value) => value !== "" && value !== undefined && value !== null,
    ),
  total_amount: Yup.string()
    .transform(parseCurrencyString)
    .test(
      "is-required",
      "Valor é obrigatório",
      (value) => !!value && value !== "0" && value !== "0.00",
    )
    .test("is-valid", "Valor deve ser maior que zero", (value) => {
      const numberValue = parseFloat(value ?? "0");
      return !isNaN(numberValue) && numberValue > 0;
    }),
  payment_date: Yup.string()
    .required("Data de pagamento é obrigatória")
    .matches(/^\d{4}-\d{2}-\d{2}$/, "Formato inválido (YYYY-MM-DD)"),
});
